<script setup lang="ts">
import { type Product } from "~/models/Product"
import CardProduct from "~/components/CardProduct.vue"
import CardOfferProductLanding from "~/components/CardOfferProductLanding.vue"
import ProductOfferCardSkeleton from "./Skeletons/ProductOfferCardSkeleton.vue"
/**
 *
 *  Props and emits section
 *
 *
 */

const props = defineProps<{
    title: string
    subtitle?: string
    data: Product[]
    subtitleClass?: string
    titleClass?: string
}>()

/**
 *
 *  Ref, computed and hooks section
 *
 *
 */
const products = computed(() => props.data)

/**
 *
 *  Life cicle events
 *
 *
 */

/**
 *
 *  Functions section
 *
 *
 */
</script>

<template>
    <div class="tw-w-full tw-mx-auto tw-pt-10 tw-pb-12 tw-px-2 md:tw-py-[50px]">
        <!-- Desktop Header -->
        <div
            class="tw-hidden md:tw-flex tw-flex-col sm:tw-flex-row sm:tw-justify-between sm:tw-items-end"
        >
            <div>
                <span
                    v-if="subtitle"
                    :class="subtitleClass"
                    class="translateUp tw-text-primary tw-text-xl tw-font-semibold tw-my-10"
                    >{{ subtitle }}</span
                >
                <h2
                    :class="`translateUp tw-text-customGray-700 tw-text-[32px] sm:tw-text-[40px] md:tw-text-[32px] tw-font-semibold ${subtitle ? 'tw-my-2' : 'tw-my-10'}`"
                >
                    {{ title }}
                </h2>
            </div>
            <NuxtLink
                to="/offers"
                class="tw-mr-11 tw-flex tw-items-center tw-gap-2"
            >
                <p
                    class="tw-text-customGray-700 tw-text-base tw-leading-6 tw-font-normal"
                >
                    Ver todo
                </p>
                <q-icon name="arrow_forward" size="18px" />
            </NuxtLink>
        </div>

        <!-- Mobile Header -->
        <div class="md:tw-hidden tw-mb-4">
            <p
                v-if="subtitle"
                :class="subtitleClass"
                class="tw-text-primary tw-text-base tw-font-semibold tw-leading-none tw-mb-2"
            >
                {{ subtitle }}
            </p>
            <div class="tw-flex tw-justify-between tw-items-center">
                <h2
                    :class="titleClass"
                    class="tw-text-customGray-700 tw-text-2xl tw-font-semibold tw-leading-tight tw-my-0"
                >
                    {{ title }}
                </h2>
                <NuxtLink
                    to="/offers"
                    class="tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10"
                >
                    <q-icon
                        name="arrow_forward"
                        size="24px"
                        class="tw-text-customGray-700"
                    />
                </NuxtLink>
            </div>
        </div>
        <div
            class="tw-grid tw-grid-cols-12 tw-grid-rows-2 tw-gap-6 tw-mt-6 md:home-px"
            v-if="!products?.length"
        >
            <ProductOfferCardSkeleton
                class="tw-col-span-12 min-[430px]:tw-col-span-6 md:tw-col-span-2"
                v-for="index in 6"
                :key="index"
            />
        </div>

        <template v-else>
            <div
                class="tw-hidden lg:tw-grid tw-grid-cols-12 tw-grid-rows-3 tw-gap-3 lg:tw-gap-6 tw-mt-3 md:home-px"
            >
                <template
                    v-for="(product, index) in products.slice(0, 6)"
                    :key="product.id"
                >
                    <CardOfferProductLanding
                        :class="`tw-hidden lg:tw-flex bento-card-container tw-mt-1 md:tw-mt-0 tw-justify-self-center tw-w-full ${(products?.length ?? 0) < 6 && (products?.length ?? 0) % 2 !== 0 && index === (products?.length ?? 0) - 1 && 'lg:!tw-col-span-12'}`"
                        :product="product"
                    />
                </template>
            </div>
            <div
                class="tw-grid lg:tw-hidden tw-grid-cols-2 tw-gap-3 md:tw-gap-6 tw-mt-1 md:home-px"
            >
                <template
                    v-for="product in products.slice(0, 6)"
                    :key="product.id"
                >
                    <CardProduct
                        class="tw-mt-1 md:tw-mt-0 tw-justify-self-center lg:tw-hidden"
                        :product="product"
                        withoutLabels
                        isHome
                    />
                </template>
            </div>
        </template>
    </div>
</template>

<style scoped>
.bento-card-container:nth-child(1),
.bento-card-container:nth-child(4),
.bento-card-container:nth-child(5) {
    @apply lg:tw-col-span-7;
}
.bento-card-container:nth-child(2),
.bento-card-container:nth-child(3),
.bento-card-container:nth-child(6) {
    @apply lg:tw-col-span-5;
}
</style>
